import React, { useEffect, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import { Loader } from '../../components/utils';

import { DataGrid } from '@mui/x-data-grid';
import {
  EditButtonStyle,
  EditonBlur,
  EditonFocus,
  EditonMouseEnter,
  EditonMouseLeave,
  localeTextGrid,
} from "../../constants";
import {IoMdClose ,IoCheckmarkSharp} from "../utils/icons"
import { ThemeProvider, createTheme } from '@mui/material';
import { useStateContext } from '../../context/ContextProvider';
import {  media } from '../../server';
import { Button } from "@mui/material";
import { HeroCharts, UsersFilter } from './utils';
import { getFillterUsers } from '../../redux/actions/user';


import { getAllMeals } from '../../redux/actions/meals';
import { getAllCategorys } from '../../redux/actions/category';
import { getAllFeaturedMeals } from '../../redux/actions/featuredMeals';
function DashboardHero() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { currentDir } = useStateContext();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState("")
  const navigate = useNavigate();
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 10,
    page: 0,
  });

  const page = paginationModel.page;
  const limit = paginationModel.pageSize;


  useEffect(() => {
    dispatch(getAllFeaturedMeals());
    dispatch(getAllMeals());
    dispatch(getAllCategorys())

  }, [dispatch]);


  useEffect(() => {
    if(errfiter){
toast.error(errfiter)
    }
    dispatch(getFillterUsers(page, limit, phoneNumber,email, name));
  }, [page, limit, phoneNumber,email, name,dispatch]);


  const { isLoading, FillterUsers, pagination ,totalusers ,errfiter} = useSelector((state) => state.Users);
  const {totalmeals} = useSelector((state) => state.Meals);
  const {totalFeaturedMeals} = useSelector((state) => state.FeaturedMeals);
  const {totalcategorys} = useSelector((state) => state.Categorys);
const ChartData =[
  {
    id:0,
    value:totalusers &&totalusers,
    value2:3,
    label:t("Users"),
    label2:"",
    color:"#ff0000"
  },
  {
    id:1,
    value:totalcategorys && totalcategorys,
    value2:3,
    label:t("categorys"),
    label2:"",
    color:"orange"
  },
  {
    id:0,
    value:totalmeals && totalmeals,
    value2:6,
    label:t("meals"),
    label2:"",
    color:"blue"
  },
  {
    id:0,
    value:totalFeaturedMeals && totalFeaturedMeals,
    value2:2,
    label:t("Featured Meals"),
    label2:"",
    color:"#fff000"
  },
]
 

  const UpdateUserHandeler = (id) => {

    navigate(`/EditUserRolePage/${id}`);
  };

  const theme = createTheme({
    direction: currentDir
  });

  const totalPages = pagination?.totalPages || 0;
  const totalItems = pagination?.totalItems || 0; // إضافة هذا إذا كان الخادم يعيد إجمالي العناصر
  const columns = [
    {
      field: 'name',
      headerName: t('Name'),
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 200,
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center pt-4">
            <p className="font-medium text-sm font-kufi">{params.value }</p>
          </div>
        )
      }
    },
    {
      field: 'email',
      headerName: t('Email'),
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 200,
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center pt-4">
                <p className="font-medium text-sm font-kufi">{params.value }</p>
          </div>
        )
      }
    },
    {
      field: 'phoneNumber',
      headerName:   t('phone Number') ,
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 250,
   
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center pt-4">
          <p className="font-medium text-sm font-kufi">{params.value}</p>
    </div>
        )
      }
    },
    {
      field: 'createdAt',
      headerName: t('created At'),
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 250,
      filterable: false,
      renderCell: (params) => {
        const date = new Date(params.value);
        const formattedDate = date.toLocaleDateString('en-GB', { // تنسيق بريطاني (يوم/شهر/سنة)
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
        
        return (
          <div className="flex items-center pt-4">
            <p className="font-medium text-sm font-kufi">{formattedDate}</p>
          </div>
        );
      }
    },
    {
      field: 'role',
      headerName:  t('is Admin') ,
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 120,
   
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="flex pt-4 items-center">
            {params.value === "user"  ?  (<div className='rounded-full p-1 w-15 h-15 text-n-1 bg-red-500'>
              <IoMdClose />
            </div>) : (<div className='rounded-full p-1 w-15 h-15 text-n-1 bg-green-500'>
              <IoCheckmarkSharp />
            </div>)}
          
          </div>
        )
      }
    },
    {
      field: 'avatar',
      headerName:  t('Image') ,
      headerClassName: 'font-semibold text-sm font-kufi',
      minWidth: 100,
      flex: 0.7,
      filterable: false, // تعطيل الفلتر لهذا العمود
      renderCell: (params) => {
        return (
          <div
            style={{
              borderRadius: "10%",
              padding:"2px",
              width: "50px",
              overflow: "hidden",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50px"
            }}
          >
            <img
              src={`${media}${params.value}`}
              alt="Product Image"
              style={{
                height: "100%",
                width: "auto",
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "cover",
                borderRadius: "50%",
              }}
            />
          </div>
        );
      },
    },
    {
      field: 'actions',
      headerName: t('Actions') ,
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 150,
      filterable: false, // تعطيل الفلتر لهذا العمود
      renderCell: (params) => {
        return (<>
   <div className="flex pt-2 w-[150px] gap-2 items-center ">

<Button className="rounded-full"
        style={EditButtonStyle}
        onMouseEnter={EditonMouseEnter}
        onMouseLeave={EditonMouseLeave}
        onFocus={EditonFocus}
        onBlur={EditonBlur} 
        onClick={() => UpdateUserHandeler(params.row._id)}
        >
         <span className='body-2'>{t("Edit")}</span> 
</Button>
          
   </div>
        
         </>
        );
      }
    },
  ];



  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (

          <div className="flex-col lg:p-16 py-14 px-5 w-full items-start ">
            <HeroCharts   data={ChartData}/>
            <h2 className="h2 text-color-1 text-center   dark:text-tcolor-1 mb-4 md:mb-8">{t("Users")}</h2>
            <UsersFilter name={name} setName={setName} email={email} setEmail={setEmail}  phoneNumber={phoneNumber}  setPhoneNumber={setPhoneNumber}/>
           
            <div className=" items-center  relative justify-center  md:m-10 mt-24 p-2 md:p-10 h-auto bg-white rounded-3xl">
  <ThemeProvider theme={theme}>
    <div style={{ width: '100%', overflowX: 'auto' }}>
      <DataGrid
        rows={FillterUsers}
        columns={columns}
        disableRowSelectionOnClick
        disableColumnSelector
        sx={{ minWidth: '1350px' }}       
        pagination
        paginationMode="server"
        rowCount={totalItems}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        pageSizeOptions={[paginationModel.pageSize]}
        getRowId={(row) => row._id}
        localeText={localeTextGrid}
      />
    </div>
  </ThemeProvider>
</div></div>
     )}
    </>
  );
}

export default DashboardHero;